module.exports = __webpack_public_path__ + "static/media/IMG_8009.c4726c58.JPG";